import React from "react";
import styled from "styled-components";
import {
  CONTENT_MAX_WIDTH,
  MOBILE_BREAK_POINT,
  MOBILE_CONTENT_MAX_WIDTH,
} from "../config/config";

export default function Footer({ className, contents }) {
  return (
    <S.Footer className={className}>
      <S.Content>
        <div>{contents}</div>
        <div>&copy; {new Date().getFullYear()} Jocoos. All rights reserved.</div>
      </S.Content>
    </S.Footer>
  );
}

const S = {};

S.Footer = styled.footer`
  position: relative;
  height: 286px;
  padding: 75px 0;
  color: white;
  background-color: #252525;
  font-size: 1rem;
  white-space: pre-wrap;
  @media (max-width: ${MOBILE_BREAK_POINT}px) {
    padding: 47px 16px;
    height: 275px;
  }
`;

S.Content = styled.div`
  position: relative;
  text-align: left;
  width: ${CONTENT_MAX_WIDTH}px;
  margin: 0 auto;
  font-family: Montserrat;
  & > div:first-child {
    font-weight: bold;
    line-height: 1.5;
    margin-bottom: 34px;
  }
  & > div:nth-child(2) {
    font-weight: normal;
    font-weight: 300;
    opacity: 0.6;
  }
  @media (max-width: ${MOBILE_BREAK_POINT}px) {
    width: ${MOBILE_CONTENT_MAX_WIDTH}px;
    text-align: left;
    font-size: 0.75rem;
  }
`;

S.Sns = styled.img`
  z-index: 100;
  position: absolute;
  top: 0;
  right: 0;

  @media (max-width: ${MOBILE_BREAK_POINT}px) {
    left: 0;
    top: 9rem;
    width: 38px;
    height: 38px;
  }
`;
